<template>
  <div class="payments-filter filters-container">
    <sorting-control type="payments" :values="sortingFields" />
  </div>
</template>

<script>
import SortingControl from './helpers/sorting-control'

const sortingFields = [
  { field: 'date', name: 'Дата' },
  { field: 'costs', name: 'Сумма' }
]

export default {
  components: {
    SortingControl
  },
  data () {
    return {
      sortingFields
    }
  }
}
</script>

<style></style>
